export default {
  name: 'nt-tag',
  props: {
    tag: {
      type: String,
      required: true
    }
  },
  render(h) {
    return h(
      this.tag,
      this.$slots.default
    )
  }
}
